module.exports = __webpack_public_path__ + "assets/img_whole-foods-market.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_whole-foods-market.jpg
 ** module id = 139
 ** module chunks = 1
 **/